import { Card } from "@mui/material";
import { useSnapshot } from "valtio";

import React from "react";

import { store } from "@store";

import {
    setIsSyncLocalModalOpened,
    syncStore,
} from "@components/Synchronization/store";
import { AppNotSynchronizedModalWrapper } from "@components/SyncModal/AppNotSynchronizedModalWrapper";
import { KeyboardWrapper } from "@components/SyncModal/KeyboardWrapper";
import { MiddlewareApiUrlInputWrapper } from "@components/SyncModal/MiddlewareApiUrlInputWrapper";

import { kioskStore } from "@pages/Kiosk/store";

import "./index.css";

export function SyncModal(): JSX.Element {
    const { isAppSynchronized, isMiddlewareApiUrlExists } = useSnapshot(store);
    const { isSyncLocalModalOpened } = useSnapshot(syncStore);
    const { isKeyboardOpened } = useSnapshot(kioskStore);
    const [isInputValueInvalid, setIsInputValueInvalid] = React.useState(false);
    const [isFieldRequired, setIsFieldRequired] = React.useState(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const keyboard = React.useRef<any>(null);

    function toggle() {
        setIsSyncLocalModalOpened(!isSyncLocalModalOpened);
    }

    React.useEffect(() => {
        setIsSyncLocalModalOpened(!isAppSynchronized);
    }, []);

    return (
        <React.Fragment>
            {isMiddlewareApiUrlExists === true ? (
                <AppNotSynchronizedModalWrapper toggleSyncModal={toggle} />
            ) : (
                <MiddlewareApiUrlInputWrapper
                    isInputValueInvalid={isInputValueInvalid}
                    setIsInputValueInvalid={setIsInputValueInvalid}
                    isFieldRequired={isFieldRequired}
                    keyboard={keyboard}
                />
            )}
            {isKeyboardOpened === true ? (
                <Card
                    style={{
                        position: "fixed",
                        bottom: 0,
                        width: "100vw",
                    }}
                    data-testid="keyboard-wrapper"
                >
                    <KeyboardWrapper
                        setIsFieldRequired={setIsFieldRequired}
                        isInputValueInvalid={isInputValueInvalid}
                        setIsInputValueInvalid={setIsInputValueInvalid}
                        keyboard={keyboard}
                    />
                </Card>
            ) : null}
        </React.Fragment>
    );
}
